<template>
  <div id="app">
    <div>
      <div id="nav">
        <div class="inner">
          <router-link to="/" class="home-link">
            <img id="home-menu-btn" src="./assets/Srf_Logo-1-transparent.png" title="Startseite" alt="Startseite">
          </router-link>
          <Backbutton />
          <span style="display: none">{{ $t('title') }}</span>

          <div v-if="loading">
            loading...
          </div>
          <span class="languages">
            <span style="margin-right: 10px" @click="changeLocale('de')">
              <img src="./assets/de.svg" title="Deutsch" alt="Deutsch">
            </span>
            <span style="margin-right: 10px;" @click="changeLocale('pl')">
              <img src="./assets/pl.svg" title="Polish" alt="Polish">
            </span>
            <span style="margin-right: 10px;" @click="changeLocale('cz')">
              <img src="./assets/cz.svg" title="Czech" alt="Czech">
            </span>
          </span>
        </div>
      </div>
      <transition :name="transitionName">
        <router-view />
      </transition>
    </div>

    <div class="pre-footer">
      <div class="row2">
        <a href="https://de.plsn.eu/" target="_blank"><img src="./assets/Interreg-2025.jpg"></a>
      </div>
    </div>

    <footer>
      <router-link to="/ds">Datenschutz</router-link> |
      <router-link to="/about">Impressum</router-link>
      <router-link to="/tb">Teilnahmebedingungen</router-link>
    </footer>
  </div>
</template>
<script type="text/babel">

import Backbutton from './components/Backbutton'

export default {
  name: 'Home',
  components: {  Backbutton},
  data: function () {
    return {
      transitionName: 'fade',
    }
  },
  computed: {
    loading() {
      return this.$root.loading
    },
  },
  watch: {
    '$route'(to, from) {
      let transitionName = ''
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
      this.transitionName = transitionName || 'fade'
      //console.log(this.transitionName)
    },
  },
  methods: {
    changeLocale(locale) {
      this.$i18n.locale = locale
      // i18n.locale = locale;
    },
  },
}
</script>

<style lang="scss">
  @import "./assets/default.scss";

</style>
<style lang="scss" scoped>
  #nav {
    padding: 10px 20px;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    background-color: #ef7d00;
    backdrop-filter: blur(5px);
    z-index: 1002;

    @media screen and (max-width: 480px) {
      padding: 0px 20px;
    }

    .inner {
      max-width: 1024px;
      margin: 0 auto;

      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      padding: 4px 0;
      box-sizing: border-box;

      .home-link {
        display: flex;
        align-items: center;

        img {
          margin-top: 0;
        }
      }
    }
  }

  .languages {
    margin-left: auto;
  }

  .languages img {
    height: 30px;
    cursor: pointer;
    vertical-align: bottom;

    @media screen and (max-width: 480px) {
      height: 20px;
    }
  }

  #home-menu-btn {
    max-width: 50px;
    vertical-align: bottom;
    margin-top: 6px;

    @media screen and (max-width: 480px) {
      max-width: 30px;
      vertical-align: baseline;
    }
  }

  .slide-left-enter-active,
  .slide-left-leave-active,
  .slide-right-enter-active,
  .slide-right-leave-active {
    transition-duration: 0.5s;
    transition-property: height, opacity, transform;
    transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
    overflow: hidden;
  }

  .slide-left-enter,
  .slide-right-leave-active {
    opacity: 0;
    transform: translate(6em, 0);
  }

  .slide-left-leave-active,
  .slide-right-enter {
    opacity: 0;
    transform: translate(-6em, 0);
  }

  button {
    padding: 15px;
    border: 1px solid green;
    font-size: 18px;
    margin: 15px;
  }
</style>
